import React from "react";
import rsi from '../Utils/rsi.webp';
import rsi1 from "../Utils/rsi1.png";
import rsi2 from "../Utils/rsi2.png";

const Rsi = () => {
  return (
    <div style={{ backgroundColor: "#E5E7EB" }}>
      <div class="container">
        <div class="article-header text-center">
          <h1 class="article-title">
            RSI provides overbought, oversold, and potential trend reversals.
          </h1>
          <p class="article-meta">RSI </p>{" "}
        </div>
        <div>
          <img src={rsi} alt="img" width="100%" height="550vp" />
        </div>
        <div class="article-content">
          <h2 class="article-section-title">Introduction</h2>
          <p>
            The Relative Strength Index (RSI) is a momentum oscillator used in
            trading to measure the speed and magnitude of price changes. It
            helps traders identify overbought or oversold conditions, potential
            reversals, and the strength of trends. Developed by J. Welles
            Wilder, it is one of the most widely used technical indicators.
            Here's an in-depth look <br />
          </p>
          <img src={rsi1} alt="types of avg img" width="80%" />
          <img src={rsi2} alt="types of avg img" width="80%" />
          {/* <img  src="./images/advLim.png" alt="types of avg img" width="80%"/>   */}
        </div>
      </div>
    </div>
  );
};

export default Rsi;
